<template>
  <div>
    <privacy-terms></privacy-terms>
    <privacy-service></privacy-service>
  </div>
</template>

<script>
  import PrivacyTerms from '../../components/privacyTerms/PrivacyTerms.vue'
  import PrivacyService from '../../components/privacyService/PrivacyService.vue'

  export default {
    name: 'app-privacy-terms',
    components: {
      PrivacyTerms,
      PrivacyService
    }
  }
</script>



// WEBPACK FOOTER //
// PrivacyTerms.vue?62a87d1a